<template>
  <div>
    <tree-view />
    <transition name="top" appear>
      <q-page-sticky position="top-right" :offset="[8, 8]" v-if="showAdd">
        <q-btn round color="secondary" @click="doAdd" icon="add"/>
      </q-page-sticky>
    </transition>
  </div>
</template>

<script>
import TreeView from 'components/tree-view.vue';

export default {
  components: { TreeView },
  name: 'list',
  computed: {
    showAdd() {
      return !this.$store.getters.isReader;
    },
  },
  methods: {
    doAdd() {
      this.$router.push('/listnew/h/root');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/list.vue